export default "__VITE_ASSET__Cpk2LjRK__"